import React, { Fragment, useState } from 'react';
import { useTranslate, usePermissions } from 'react-admin';

import { Drawer, EditButton } from '~/components';
import { EditForm } from '~/components/ra';
import { Pricing } from '~/types';
import PricingForm from '~/resources/solutions/components/Pricing/PricingForm';
import { l } from '~/resources/pricings/PricingShow';
import { useEditMode } from '~/hooks/useEditModeContext';

interface Props {
  record?: Pricing;
}

const PricingEdit = (props: Props) => {
  const { record } = props;

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const { permissions } = usePermissions();
  const hasUpdatePermission =
    permissions?.includes('solution.pricing.update') ||
    permissions?.includes('solution.pricing.create');

  const { editMode } = useEditMode();

  return (
    <Fragment>
      <EditButton onClick={handleOpen} disabled={!hasUpdatePermission} />
      <Drawer heading={t('editPricing')} open={open} onClose={handleClose} editMode={editMode}>
        {record && (
          <EditForm
            resource='pricings'
            record={record}
            closeParent={handleClose}
            disabled={!hasUpdatePermission}
            withSaveConfirmation={false}
          >
            <PricingForm edit pricingRecord={record} />
          </EditForm>
        )}
      </Drawer>
    </Fragment>
  );
};

export default PricingEdit;
